import { grey } from "@mui/material/colors";
import { SxProps } from "@mui/system";

export const formStyles: Record<string, SxProps> = {
    heading: {
        mt: 4,
        // heading style
        px: 2,
        py: 1,
        bgcolor: grey[300],
        borderRadius: 1,
    },
};
